<template>
  <div  class="product-container">
      <div class="product-contents" v-if="product">
        <div v-if="category" class="product-category">
          <span class="pointer" @click="$router.push('/products?index=' + category.order)">{{ category.name }}</span>
          <span class="mx-2">/</span>
          <strong>{{ product.title }}</strong>
        </div>

        <div class="product-image">
          <img :src="product.thumbnail"/>
        </div>

        <div class="product-overview">
          <div class="title">
            <h1>
              {{product.title}}
            </h1>
            <p>
              {{product.subtitle}}
            </p>
          </div>

          <button class="vhp-button large bold text" style="width:100%; " @click="$router.push('/contact')">{{$t('문의하기')}}</button>

        </div>

        <div class="product-description" v-if="product.content" v-html="product.content"/>


      </div>


      <div class="product-footer">
       
        T 055-724-2999 | E admin@vazilcompany.com

        <br/>
        <br/>
        <button class="vhp-button my-2 large" style="display: inline-block;" @click="$router.go(-1)">
          {{$t('목록보기')}}
        </button>
      </div>
  </div>

</template>

<script>
export default {
  name: "ProductLayout",
  components:{
  },
  watch:{
    product(){
      if(this.product?.category) {
        this.getCategory(this.product.category)
      }
    }
  },
  props:{
    product: Object
  },
  data() {
    return{
      category: null
    }
  },
  mounted(){
    this.getCategory(this.product.category)
  },
  methods:{
    async getCategory(categoryId) {

      if(categoryId) {
        await this.$axios.get('/category/details?id=' + this.product.category).then(res=>{
          if(res.data) {
            this.category = res.data
          }
        }).catch(err=>{console.log(err)})
      }
    }
  }
}

</script>

<style lang="scss" src="./ProductLayout.scss"></style>
